import React, { useEffect, useState } from 'react'
import MicRecorder from 'mic-recorder-to-mp3';
import { T } from '../../traks';
import { RenderIf } from '../../helpers/RenderIf';
const audioRecorder = new MicRecorder({ bitRate: 320 });

const sec2hms = (ts) => {
	const hours = parseInt(ts / 3600);
	const mins = parseInt((ts % 3600) / 60);
	const secs = ts - mins * 60 - hours * 3600;

	return <span>{hours < 10 ? "0" + hours : hours}:{mins < 10 ? "0" + mins : mins}:{secs < 10 ? "0" + secs : secs}</span>;
}

const CountTimeSince = ({ className = "", timestamp, isRecording }) => {
	const [trigger, setTrigger] = useState(0);

	useEffect(() => {
		if (isRecording) {
			const timer = setTimeout(() => {
				setTrigger(ot => ot + 1);
			}, 1000);

			return () => clearTimeout(timer);
		}
	}, [trigger, isRecording]);

	const showTime = () => {
		const now = Math.floor(Date.now() / 1000);
		const diff = now - timestamp;

		return sec2hms(diff);
	}

	return (
		<div className={className}>
			{showTime()}
		</div>
	);
};

export const RecordAudio = ({ setFiles }) => {
	const [isBlocked, setIsBlocked] = useState(false)
	const [blobUrl, setBlobUrl] = useState("")
	const [isRecording, setIsRecording] = useState(false)
	const [recStartTs, setRecStartTs] = useState(0);
	useEffect(() => {
		const getMedia = async () => {
			await navigator.mediaDevices.getUserMedia({ audio: true, video: false },
				() => {
					console.log('Permission Granted');
					setIsBlocked(false);
				},
				() => {
					console.log('Permission Denied');
					setIsBlocked(true)
				},
			);
		}
		getMedia()
	}, [])

	const start = () => {
		if (isBlocked) {
			console.log('permission Denied');
		} else {
			setFiles((prevVal) => prevVal.filter(el => !el.name.includes("audioContent")))
			setRecStartTs(Math.floor(Date.now() / 1000));
			audioRecorder.start().then(() => {
				setIsRecording(true)
			}).catch((e) => {
				console.log(e)
			});
		}
	};

	const stop = () => {
		audioRecorder.stop().getMp3().then(([buffer, blob]) => {
			const blobUrl = URL.createObjectURL(blob)
			setBlobUrl(blobUrl);
			setIsRecording(false);
			var d = new Date();
			const filename = "audioContent" + d.valueOf() + ".mp3"
			var file = new File([blob], filename, { type: "audio/mp3" })
			setFiles((prevState) => {
				return [
					...prevState,
					{
						id: (new Date()).valueOf(),
						file: file,
						size: file.size,
						name: file.name,
						type: file.type
					},
				]
			});
		}).catch((e) => console.log('We could not retrieve your message'));
	};

	return (
		<div className="d-flex flex-column mx-auto">
			<div className="d-flex flex-row mt-5 mb-3">
				<button className="btn me-4 sibilus_border" onClick={start} disabled={isRecording} type="button">
					<T>Record</T>
				</button>
				<button className="btn sibilus_border" onClick={stop} disabled={!isRecording} type="button">
					<T>Stop</T>
				</button>
			</div>
			<div>
				<audio
					src={blobUrl}
					controls={true}
					className="mt-2 w-100"
				/>
			</div>
			<RenderIf condition={recStartTs}>
				<CountTimeSince timestamp={recStartTs} isRecording={isRecording} />
			</RenderIf>
		</div>
	)
}
